function Dots() {
  return (
    <span className="inline-flex gap-[4px] items-center align-middle ml-2">
      <span className="thinking-dot" style={{ animationDelay: "0ms" }} />
      <span className="thinking-dot" style={{ animationDelay: "160ms" }} />
      <span className="thinking-dot" style={{ animationDelay: "320ms" }} />
    </span>
  );
}

interface Props {
  who: "elena" | "student";
  text: string;
  thinking?: boolean;
}

export default function ChatBubble({ who, text, thinking }: Props) {
  if (who === "elena") {
    return (
      <div className="self-start max-w-[88%] animate-fade-in">
        <div className="font-display font-semibold tracking-[-0.01em] text-success text-[0.8125rem] mb-1">Elena</div>
        <div className="bg-[#152a1e] rounded-2xl rounded-tl-sm px-4 py-3">
          <p className="text-[0.9375rem] leading-6 text-text">{text}{thinking && <Dots />}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="self-end max-w-[80%] animate-fade-in flex flex-col items-end">
      <div className="font-display font-semibold tracking-[-0.01em] text-text-tertiary text-[0.8125rem] mb-1">You</div>
      <div className="bg-[#26262b] rounded-2xl rounded-tr-sm px-4 py-3">
        <p className="text-[0.9375rem] leading-6 text-text">{text}</p>
      </div>
    </div>
  );
}
